import type { AdminCompanyDetailDto } from '@@types/api.types';
import React from 'react';

type AdminOrganizationProfileTileProps = {
  organization: AdminCompanyDetailDto;
};

export const AdminOrganizationProfileTile: React.FC<AdminOrganizationProfileTileProps> = (props) => {
  const { organization } = props;

  return (
    <div className="p-4 rounded-lg border border-gray-200 bg-white">
      <div className="flex flex-col gap-3">
        <h3 className="text-sm font-semibold text-gray-900">Profile</h3>

        <div className="flex flex-col gap-1">
          <span className="text-xs font-medium text-gray-500">Location</span>
          <span className="text-sm text-gray-900">
            {organization.city || organization.state || organization.country
              ? [organization.city, organization.state, organization.country].filter(Boolean).join(', ')
              : '—'}
          </span>
        </div>

        {organization.description && (
          <div className="flex flex-col gap-1">
            <span className="text-xs font-medium text-gray-500">Description</span>
            <span className="text-sm text-gray-900">{organization.description}</span>
          </div>
        )}

        {organization.yearFounded && (
          <div className="flex flex-col gap-1">
            <span className="text-xs font-medium text-gray-500">Year Founded</span>
            <span className="text-sm text-gray-900">{organization.yearFounded}</span>
          </div>
        )}
      </div>
    </div>
  );
};
